import { Group, TextInput, Checkbox, Button, SimpleGrid, Stack } from "@mantine/core";
import { useState } from "react";
import { useAuth } from "@/contexts/auth.ctx.tsx";
import { notifications } from "@mantine/notifications";

export default function SingleUserInvite() {
    const { injectHeader } = useAuth();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState<string | undefined>(undefined);
    const [team, setTeam] = useState<string | undefined>(undefined);
    const [privileged, setPrivileged] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleInvite = async () => {
        setIsLoading(true);
        const req = new Request('/api/auth/invite', {
            method: 'POST',
            body: JSON.stringify({ name, email, phone, team, privileged }),
        });
        injectHeader(req);
        const res = await fetch(req);
        if (res.ok) {
            clearForm();
            notifications.show({
                title: 'Invite Sent',
                message: 'Invite sent to user via email',
                color: 'green',
            });
        } else {
            notifications.show({
                title: `Error - ${res.status}`,
                message: `Failed to send invite: ${await res.text()}`,
                color: 'red',
            });
            console.error('Failed to send invite', res.statusText);
        }
        setIsLoading(false);
    }

    const clearForm = () => {
        setName('');
        setEmail('');
        setPhone(undefined);
        setTeam(undefined);
        setPrivileged(false);
    }

    return (<Group wrap='nowrap' justify="space-between" align="flex-end">
        <SimpleGrid cols={2} flex={1}>
            <TextInput required label="Name" placeholder="Steven Privacy" value={name} onChange={(e) => setName(e.target.value)} />
            <TextInput required label="Email" placeholder="steven@privacy.com" value={email} onChange={(e) => setEmail(e.target.value)} />
            <TextInput label="Phone" placeholder="123.883.2354" value={phone} onChange={(e) => setPhone(e.target.value)} />
            <TextInput label="Team" placeholder="Warmditch Tanker" value={team} onChange={(e) => setTeam(e.target.value)} />
        </SimpleGrid>
        <Stack>
            <Checkbox label="Privileged" checked={privileged} onChange={(e) => setPrivileged(e.target.checked)} />
            <Button loading={isLoading} onClick={handleInvite} disabled={!name || !email}>Invite</Button>
        </Stack>


    </Group>)
}